
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.75 45a13.75 13.75 0 1027.5 0 13.75 13.75 0 00-27.5 0zM27.5 33.75H3.75a2.5 2.5 0 01-2.5-2.5V3.75a2.5 2.5 0 012.5-2.5h32.5a2.5 2.5 0 012.5 2.5v21.155m20 2.3a2.5 2.5 0 01-3.617 2.235l-10-5a2.5 2.5 0 01-1.383-2.235v-9.41a2.5 2.5 0 011.383-2.235l10-5a2.5 2.5 0 013.617 2.235v19.41z","stroke":"#666","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M38.75 38.75v12.54L50.078 45 38.75 38.75z","stroke":"#666","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    